<template lang="pug">
span.table-reservation(:class="{'have-slot' : !request.onHold && request.slotsCount, 'hold': request.onHold }")
  template(v-if="request.slotsCount !== null && request.slotsCount !== undefined") 
    span {{ request.slotsCount}} | 
  | {{ request.examDate }} - {{ request.location }} 
  v-menu(v-if="index === 1 && filteredRequests.length > 2" v-model="menuShowing" top)
    template( v-slot:activator="{ on }")
      div(v-on="on").table-reservation__more  +{{ filteredRequests.length - 2 }} more
    v-list
      v-list-item(v-for="(fullRequest, fullIndex) in filteredRequests" :key="fullIndex").auto-min
        v-list-item-title.table-reservation(:class="{'have-slot' : !fullRequest.onHold && fullRequest.slotsCount, 'hold': fullRequest.onHold }")
          template(v-if="fullRequest.slotsCount !== null && fullRequest.slotsCount !== undefined") {{ fullRequest.slotsCount}} | 
          | {{ fullRequest.examDate }} - {{ fullRequest.location }} 
</template>

<script>
export default {
  props: {
    request: {
      type: Object,
      required: true
    },
    filteredRequests: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    menuShowing: false
  })
}
</script>

<style lang="scss" scoped> 
.auto-min {
  min-height: auto;
}

.table-reservation {
  font-size: 10px;
  display: inline-block;
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: $title-second;
  line-height: 1.3;
  &__more {
    color:$primary-color;
    cursor: pointer;
  }
}

.have-slot {
  color: #24a255;
}

.hold {
  color: $error-color;
}
</style>
